import React from 'react';

export default function VerificationBanner(props) {
  const { onOpen } = props;

  return (
    <div className="verification-banner">
      <span style={{ color: 'red' }}>&#9888;</span>
      <span>To create &quot;boosted posts&quot; or &quot;posts only&quot; with our tool, you&apos;ll need to verify your domain</span>
      <button type="button" className="verification-button" onClick={onOpen}>Verify Domain</button>
    </div>
  );
}
